import {
  API_UI_SETTINGS
} from 'constants/ApiUrls'
import { METHOD_PUT } from 'constants/Methods'
import { createApi } from 'utils/index'

export const getSettings = () => createApi(API_UI_SETTINGS)
export const updateSettings = (data) => createApi(API_UI_SETTINGS, METHOD_PUT, data)
